import React, { Component } from 'react'
import { message, Modal, Tag, Button, Input, Switch } from 'antd'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import classnames from 'classnames'
import PricingModal from '../../../components/PricingModal'
import CloudFlyerAPI from '../../../api/CloudFlyerAPI'
import { refresh_profile } from '../../../actions/auth'
import BillingForm from '../../../components/Billing/BillingForm'

import './styles.scss'

const PackageCard = ({
    productName,
    product,
    amountYear,
    amountMonth,
    per,
    children,
    activated,
    role,
    onSendRequest,
    onActivate,
}) => (
    <div className="package-card">
        <div>
            <div className="package-name">
                <h1>{productName}</h1>
            </div>
            <hr />
            <div className="package-amount">
                <div className="dollar-sign">$</div>
                <div className="amount">
                    {per === 'Year' ? amountYear : amountMonth}
                </div>
                {per && <div className="per">/{per}</div>}
            </div>
            <hr />
            <h3>Includes: </h3>
            <div className="package-children">{children}</div>
        </div>
        <div>
            <hr />
            <div className="package-btn-container">
                {activated ? (
                    <Tag className="activated-tag" color="#1b5e20">
                        Service Activated
                    </Tag>
                ) : role === 'Owner' ? (
                    <Button
                        type="primary"
                        className="package-activate-btn"
                        onClick={() =>
                            onActivate({
                                productName,
                                product,
                                amountYear,
                                amountMonth,
                                per,
                            })
                        }>
                        Activate Now
                    </Button>
                ) : (
                    <Button
                        type="primary"
                        className="package-activate-btn"
                        onClick={() =>
                            onSendRequest(productName, product, per)
                        }>
                        Send Request
                    </Button>
                )}
            </div>
        </div>
    </div>
)

const CloudFlyerFree = props => (
    <PackageCard productName="CloudFlyer Free" amountMonth="0" activated>
        <ul>
            <li>Manage AWS, Wasabi & Azure accounts from a single page</li>
            <li>Costs & Usage Notifications</li>
            <li>Drag & Drop files to/from clouds</li>
            <li>Search Across Clouds</li>
            <li>Secure File Share</li>
            <li>500 GBs ftX Transfer</li>
        </ul>
    </PackageCard>
)

const CloudFlyerFtX = ({ role, onSendRequest, onActivate }) => (
    <PackageCard
        productName="CloudFlyer ftX"
        product="ftx"
        amountMonth=".05"
        per="GB"
        role={role}
        onSendRequest={onSendRequest}
        onActivate={() => {}}>
        <ul>
            <li>Optimized data movement across any network</li>
            <li>Speeds tested up to 40GB/sec</li>
            <li>AI Network Management</li>
            <li>100% reliable data delivery</li>
            <li>Precise bandwidth control for maximum transfer speeds</li>
            <li>User & Group management for project-based collaboration</li>
        </ul>
    </PackageCard>
)

const LiteMAM = ({ per, role, onSendRequest, onActivate, activated }) => (
    <PackageCard
        productName="LiteMAM"
        product="search"
        amountMonth="20"
        amountYear="199"
        per={per}
        role={role}
        onSendRequest={onSendRequest}
        onActivate={onActivate}
        activated={activated}>
        <ul>
            <li>Advanced Search across multiple cloud accounts</li>
            <li>Enhanced MetaData Search</li>
            <li>Custom Value Search</li>
            <li>Video Player</li>
            <li>Copy, Share and Download</li>
            <li>ftX High speed Download option</li>
            <li>Available for S3, Wasabi and Azure</li>
        </ul>
    </PackageCard>
)

const AWSAnalytics = ({ per, role, onSendRequest, onActivate, activated }) => (
    <PackageCard
        productName="AWS Analytics"
        product="analytics"
        amountMonth="20"
        amountYear="199"
        per={per}
        role={role}
        onSendRequest={onSendRequest}
        onActivate={onActivate}
        activated={activated}>
        <ul>
            <li>
                Monitor every service within your AWS, Wasabi or Azure accounts
            </li>
            <li> Granular review of cost & usage</li>
            <li> Forecast monthly spend</li>
            <li> CVS Downloads for custom data & reporting</li>
            <li> Storage Cost Comparisons between S3, Wasabi & Azure</li>
        </ul>
    </PackageCard>
)

const BudgetManager = ({ per, role, onSendRequest, onActivate, activated }) => (
    <PackageCard
        productName="Budget Manager"
        product="finance"
        amountMonth="20"
        amountYear="199"
        per={per}
        role={role}
        onSendRequest={onSendRequest}
        onActivate={onActivate}
        activated={activated}>
        <ul>
            <li>Real time cloud costs for AWS, Azure and Wasabi accounts</li>
            <li>Customized Budget Manage</li>
            <li>Add any Cloud Service to track costs against budget</li>
            <li>Unlimited notifications</li>
            <li>Comparisons between cloud services</li>
            <li>Custom reporting</li>
        </ul>
    </PackageCard>
)

class Pricings extends Component {
    constructor(props) {
        super(props)

        const activatedPackages = this.props.user.packages
            ? this.props.user.packages.map(p => p.title)
            : []

        this.state = {
            per: 'Month',
            pricingModal: {
                visible: false,
                productName: '',
                product: '',
                monthlyPricing: '',
                annuallyPricing: '',
            },
            activatedPackages,
        }

        this.handleChecked = this.handleChecked.bind(this)
        this.sendRequest = this.sendRequest.bind(this)
        this.activate = this.activate.bind(this)
        this.hidePricingModal = this.hidePricingModal.bind(this)
    }

    hidePricingModal() {
        this.setState({
            pricingModal: {
                ...this.state.pricingModal,
                visible: false,
            },
        })
    }

    handleChecked(isPerYear) {
        const per = isPerYear ? 'Year' : 'Month'
        this.setState({ per })
    }

    sendRequest(productName, product, period) {
        CloudFlyerAPI.packages
            .request_service(product, period)
            .then(res => message.success('Request has been sent to the owner'))
            .catch(res =>
                message.error('Could not send activation request to the owner')
            )
    }

    activate({ productName, product, amountYear, amountMonth, per }) {
        this.setState({
            pricingModal: {
                ...this.state.pricingModal,
                productName: productName,
                product: product,
                monthlyPricing: amountMonth,
                annuallyPricing: amountYear,
                visible: true,
            },
        })
    }

    render() {
        const { per, activatedPackages, pricingModal } = this.state
        const role = this.props.user.role.title
        return (
            <div className="pricings">
                <PricingModal
                    productName={pricingModal.productName}
                    product={pricingModal.product}
                    monthlyPricing={pricingModal.monthlyPricing}
                    annuallyPricing={pricingModal.annuallyPricing}
                    onClose={period => console.log('confirmed : ' + period)}
                    controlVisibility={true}
                    show={
                        !this.props.user.organization.is_cbs &&
                        pricingModal.visible
                    }
                    onCancel={this.hidePricingModal}
                />

                <h1 className="pricings-header">
                    Simple Pricing Built For <b>Any Size Team</b>
                </h1>
                <h3 className="pricings-subheader">
                    Add Features & Users as needed
                </h3>
                <div className="plan-switch">
                    <div className="plan">Monthly</div>
                    <Switch onChange={this.handleChecked} />
                    <div className="plan">Annual</div>
                </div>
                <div className="package-cards">
                    <CloudFlyerFree />
                    <CloudFlyerFtX
                        role={role}
                        onSendRequest={this.sendRequest}
                        onActivate={this.activate}
                    />
                    <LiteMAM
                        per={per}
                        role={role}
                        onSendRequest={this.sendRequest}
                        onActivate={this.activate}
                        activated={activatedPackages.includes('LiteMAM')}
                    />
                    <AWSAnalytics
                        per={per}
                        role={role}
                        onSendRequest={this.sendRequest}
                        onActivate={this.activate}
                        activated={activatedPackages.includes('Analytics')}
                    />
                    <BudgetManager
                        per={per}
                        role={role}
                        onSendRequest={this.sendRequest}
                        onActivate={this.activate}
                        activated={activatedPackages.includes('Finance')}
                    />
                </div>
            </div>
        )
    }
}

export default withRouter(
    connect(
        ({ auth: { user } }) => ({ user }),
        dispatch => bindActionCreators({ refresh_profile, dispatch }, dispatch)
    )(Pricings)
)
